import createAxios from './../../../axiosHttps';

export const integrationsAlierSGAOrderOutboxQueueAdminService = {
  getOrderOutboxQueue,
};

const axiosInstance = createAxios();

function buildQueryUrl(basePath, query = {}) {
    const url = new URL(basePath, window.location.origin);
    const params = new URLSearchParams();

    // Agregar los parámetros a la URL
    Object.keys(query).forEach(key => {
        if (query[key] !== undefined && query[key] !== null) {
            params.append(key, query[key]);
        }
    });

    // Devolver la URL completa
    url.search = params.toString();
    return url.pathname + url.search;
}

async function getOrderOutboxQueue(filters, pagination) {
    const query = {
        page: pagination ? pagination.currentPage - 1 : 0,
        limit: pagination ? pagination.rows : 20,
        search: filters?.search,
        status: filters?.status,
        sort: filters?.sort?.sort ? filters?.sort?.sort : '_id',
        order: filters?.sort?.order ? filters?.sort?.order : 'ascending',
        action: filters?.action,
    };
    const urlPath = buildQueryUrl(`/administration/integrations/alier/order_outbox_queue`, query);
    return await axiosInstance.get(urlPath).catch(handleError);
}

function handleError(error) {
    console.error('API call failed:', error);
    throw axiosInstance;
}
